import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, first, switchMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GenericErrorComponent } from '../components/main/modals/generic-error/generic-error.component';
import { AuthAdaptorService } from '@aiwyn/auth';
import { MatDialog } from '@angular/material/dialog';
import { LaunchDarklyFlag, LaunchDarklyService } from '@aiwyn/config';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private dialog: MatDialog,
    private authAdaptor: AuthAdaptorService,
    private readonly launchDarklyService: LaunchDarklyService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          // It's something bad - like a 400 or a 500 or 503.
          // this.showModalAlertMessage();
          // Our error tracking only notifies us the first time an error is received. Create a unique error message so that we are notified 1 time per user/guest.
          console.error(`HttpErrorInterceptor caught an error: ${error.message}
           ${this.authAdaptor.getContactIdOrNull !== null ? this.authAdaptor.contactUsername : this.authAdaptor.anonymousUserUuid}`
          );
        }
        if (error.status === 0) {
          // A client-side or network error occurred. Handle it accordingly.
          return this.launchDarklyService.getFeatureFlag(LaunchDarklyFlag.LOG_STATUS_ZERO_ERRORS)
            .pipe(
              tap(enabled => {
                if (enabled) {
                  console.warn('A client network error occurred:', error.message);
                  console.error('A client network error occurred:', error.error);
                }
              }),
              // after side-effects, re-throw the original error
              switchMap(() => throwError(error)),
            );
        }
        return throwError(error);
      })
    ) as Observable<HttpEvent<any>>;
  }

  private showModalAlertMessage() {
    if (this.NoDialogsAreDisplayed()) {
      const errorModal = this.dialog.open(GenericErrorComponent);
      errorModal.afterClosed().pipe(first()).subscribe(() => {
      });
    }
    return null;
  }

  private NoDialogsAreDisplayed(): boolean {
    return ((!this.dialog.openDialogs || this.dialog.openDialogs.length <= 0));
  }
}
